import { render, staticRenderFns } from "./FeedBacks.vue?vue&type=template&id=d00467d4&scoped=true&"
import script from "./FeedBacks.vue?vue&type=script&lang=js&"
export * from "./FeedBacks.vue?vue&type=script&lang=js&"
import style0 from "./FeedBacks.vue?vue&type=style&index=0&id=d00467d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d00467d4",
  null
  
)

export default component.exports